import Vue from 'vue'
import Vuelidate from 'vuelidate';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import App from './App.vue'
import router from './router'
import store from './store'

import { dateFormat } from '@/mixins';

import moneyFilter from '@/filters/money';
import moneyFilter2 from './filters/money2';
import slugify from '@/filters/slugify';

const options = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
  timeout: 2000,
  position: 'top-right',
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  // Disable adding same toast as current
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter(
      t => t.type === toast.type && t.content === toast.content
    ).length !== 0) {
      // Returning false discards the toast
      return false;
    }
    // You can modify the toast if you want
    return toast;
  }
};

Vue.use(Toast, options);
Vue.use(Vuelidate);
Vue.filter('money', moneyFilter);
Vue.filter('money2', moneyFilter2);
Vue.filter('slugify', slugify);

Vue.config.productionTip = false;
Vue.mixin(dateFormat);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

export const EventBus = new Vue();
